import { connect } from 'react-redux';
import { NextPageContext } from 'next';

import CmsPage from 'models/CmsPage';
import CompanySite from 'models/CompanySite';
import User from 'models/User';

import { single as singleCmsPage } from 'requests/cmsPages';
import { single } from 'requests/companySite';
import { State as StoreState } from 'store/state';

import { Props as SectionJobProps } from './sections/Company';
import Component from './component';

export interface Props {
    company?: CompanySite;
    notFound?: boolean;
    cmsPage?: CmsPage;
    state?: {
        authToken?: string;
        profile?: User;
    }
}

export interface PageContent {
    companyCopy: SectionJobProps;
}
const mapStateToProps = (state: StoreState, ownProps?: Props): object => {
    return {
        state: {
            authToken: state.user.authToken,
            profile: state?.user.profile,
        },
    };
};

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let company: CompanySite = null;
    let cmsPage: CmsPage = null;

    try {
        await Promise.all([
            single({ slug: appContext?.query?.slug.toString() }),
            singleCmsPage({ slug: 'companysite' }),
        ]).then(responses => {
            company = responses[0];
            cmsPage = responses[1];
        });
    } catch (error) {
        console.error(error);

        return {
            notFound: true,
        };
    }

    return {
        company,
        cmsPage: cmsPage || null,
    };
};

export default connect(mapStateToProps, null)(Component);